import { render, staticRenderFns } from "./list-special-price.vue?vue&type=template&id=68e9a924&scoped=true"
import script from "./list-special-price.vue?vue&type=script&lang=js"
export * from "./list-special-price.vue?vue&type=script&lang=js"
import style0 from "./list-special-price.vue?vue&type=style&index=0&id=68e9a924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e9a924",
  null
  
)

export default component.exports